import { SVGProps } from 'react';

const ScrollText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 12h-5m5-4h-5M6 8H3a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v12M4 3a2 2 0 0 1 2 2v14a2 2 0 0 0 2 2m0 0h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 0 1-2 2"
    />
  </svg>
);
export default ScrollText;
